import { StrictMode } from "react";

import { ConfigProvider } from "antd";
import esES from "antd/es/locale/es_ES";
import dayjs from "dayjs";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { Salvavidas } from "./components/Salvavidas";
import { transporteDirectus } from "./lib/api/client";
import { TransporteContexto } from "./lib/api/transporte";
import { Rutas } from "./routes";
import { tema } from "./theme/tokens";

import "dayjs/locale/es";
import "./styles/base.css";

dayjs.locale("es");

const contenedor = document.getElementById("root");
if (!contenedor) throw new Error("Falta #root en index.html");

createRoot(contenedor).render(
  <StrictMode>
    <ConfigProvider locale={esES} theme={tema}>
      {/* creatorhv habla con Directus; la suite de personas monta el editor con otro transporte. */}
      <TransporteContexto.Provider value={transporteDirectus}>
        <BrowserRouter>
          <Salvavidas>
            <Rutas />
          </Salvavidas>
        </BrowserRouter>
      </TransporteContexto.Provider>
    </ConfigProvider>
  </StrictMode>,
);
